(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxStackedColumnChart', MxStackedColumnChartDirective);

	MxStackedColumnChartDirective.$inject = ['$injector', 'mx.SolutionBuilderAgent.BaseChartService'];

	function MxStackedColumnChartDirective($injector, baseChartService) {
		var directive = baseChartService.mxBaseChartDirective($injector);

		directive.controller = MxStackedColumnChartCtrl;
		directive.bindToController.showOnlyTopColumns = '@';
		return directive;
	}

	MxStackedColumnChartCtrl.$inject = ['$injector', '$controller', '$scope', '$attrs', '$element', 'mx.SolutionBuilderAgent.BaseChartService'];

	function MxStackedColumnChartCtrl($injector, $controller, $scope, $attrs, $element, baseChartService) {
		var vm = $controller('mx.SolutionBuilderAgent.MxBaseChartController', {
			$injector: $injector,
			$scope: $scope,
			$attrs: $attrs,
			$element: $element,
		});

		var minWidthOfSeries = 20;

		vm.getChartConfig = function () {
			return baseChartService.getBaseChartConfig(vm).then(function (baseConfig) {
				var config = angular.extend({}, baseConfig);
				config.plotOptions = {
					series: {
						stacking: 'normal',
						events: {
							click: function () {
								var hoveredChart = this.data.filter(function (item) {
									return item.state === 'hover';
								})[0];
								vm.onChartClick(hoveredChart, hoveredChart.series);
							},
						},
					},
				};

				// old tooltip function is used instead of new one in base-chart. It is used to avoid breaking change whit tooltip like {x} - {y}
				config.tooltip = {
					formatter: function () {
						var y = this.y % 1 === 0 ? this.y : Number(this.y).toFixed(2);
						var x = this.series.name;
						var s = this.key;

						if (typeof vm.tooltipFormat === 'string' && vm.tooltipFormat.length > 0) {
							return vm.tooltipFormat.replace(/{x}/g, x).replace(/{y}/g, y).replace(/{s}/g, s);
						} else {
							return x + ' — ' + y;
						}
					},
				};

				vm.reorderAllStackedSeriesAsFirstSeries(config.series);

				config.series.forEach((serie) => (serie.type = 'column'));

				if (vm.showOnlyTopColumns === 'true') {
					var dataConfig = angular.copy(config.series);
					var numOfSeriesToShow = 0;

					config.responsive.rules.push({
						condition: {
							callback: function () {
								var newNumOfSeriesToShow = Math.floor(this.chartWidth / minWidthOfSeries);
								if (newNumOfSeriesToShow === numOfSeriesToShow) {
									return;
								}
								numOfSeriesToShow = newNumOfSeriesToShow;

								this.series.forEach(function (serie, index) {
									if (serie.data.length !== numOfSeriesToShow) {
										serie.setData(
											dataConfig[index].data.filter(function (data, index) {
												return index < numOfSeriesToShow;
											})
										);
									}
								});
							},
						},
					});
				}

				return config;
			});
		};

		return vm;
	}
})();
